import { IconLineClose } from "@kalodata/kds-design-icons";
import { TestId } from "@shared/testIds";
import { Trans } from "react-i18next";

export interface PostVideoModalHeaderProps {
  onClose: () => void;
}

export const PostVideoModalHeader = ({ onClose }: PostVideoModalHeaderProps) => {
  return (
    <div className="flex shrink-0 items-center justify-between px-[16px] pt-[16px] pb-0">
      <h2 className="m-0 text-[16px] font-semibold leading-[24px] text-kds-fg">
        <Trans>Post video</Trans>
      </h2>
      <button
        type="button"
        aria-label="Close"
        data-testid={TestId.PostVideoModalClose}
        onClick={onClose}
        className="flex size-[32px] shrink-0 cursor-pointer items-center justify-center rounded-[8px] border-0 bg-transparent p-[6px] text-kds-fg hover:bg-kds-bg-overlay"
      >
        <IconLineClose size={20} />
      </button>
    </div>
  );
};
